export const ORDER_TYPES = {
    DELIVERY: "DELIVERY",
    PICKUP: "PICKUP",
    DINE_IN: "DINE_IN",
}
